import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtistContracts = (params, page = 1, pageSize = 2147483647, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-contracts/?page=' + page + '&page_size=' + pageSize, {
    params: params,
    cancelToken: cancelToken?.token
  })
}

export const getArtistContract = (id) => {
  return axios.get(URL_PREFIX + '/artist-contracts/' + id + '/')
}

export const postArtistContract = (params) => {
  return axios.post(URL_PREFIX + '/artist-contracts/', params)
}

export const patchArtistContract = (id, param) => {
  return axios.patch(URL_PREFIX + '/artist-contracts/' + id + '/', {
    ...param
  })
}

export const deleteArtistContract = (id) => {
  return axios.delete(URL_PREFIX + '/artist-contracts/' + id + '/')
}
